module.exports = __webpack_public_path__ + "static/media/1.21efb744.jpg";